import { Href, Redirect } from 'expo-router';
import React from 'react';

export default function ExternalCardsPage() {
  const tab = 'cards';
  return <Redirect href={`/myvaro/external-accounts?tab=${tab}` as Href} />;
}
